import { useState } from "react";

interface BooleanFieldProps {
  label: string;
  value: boolean | undefined;
  onChange: (value: boolean) => void;
  description?: string;
}

export function BooleanField({ label, value, onChange, description }: BooleanFieldProps) {
  const checked = value ?? false;
  const [showTip, setShowTip] = useState(false);

  return (
    <div className="group/field rounded-radius-sm px-1.5 py-1 transition-colors hover:bg-surface-sunken/50">
      <div className="flex items-center gap-2">
        <div
          className="relative flex w-28 shrink-0 items-center gap-1"
          onMouseEnter={() => { if (description) setShowTip(true); }}
          onMouseLeave={() => setShowTip(false)}
        >
          <span className="truncate text-[11px] text-text-secondary">{label}</span>
          {description && (
            <span className="text-[9px] text-text-muted/40 opacity-0 transition-opacity group-hover/field:opacity-100">?</span>
          )}
          {showTip && description && (
            <div className="absolute left-0 bottom-full z-50 mb-1 w-52 rounded-radius-sm border border-border-subtle bg-surface-overlay px-2.5 py-1.5 text-[10px] leading-relaxed text-text-secondary shadow-md">
              {description}
            </div>
          )}
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          onClick={() => onChange(!checked)}
          className={`relative h-5 w-9 rounded-radius-full transition-colors ${
            checked ? "bg-accent" : "bg-border-muted"
          }`}
        >
          <span
            className={`absolute top-0.5 left-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition-transform ${
              checked ? "translate-x-4" : "translate-x-0"
            }`}
          />
        </button>
      </div>
    </div>
  );
}
